<template>
    <b-modal v-if="!loading" id="detail_form" ref="detail_form"
             @hidden="resetForm" no-close-on-backdrop
             modal-class="modal-right modal-dialog-scrollable">

        <template v-slot:modal-title>
            {{ !edit ? 'Add New Detail' : 'Edit Detail' }}
        </template>

        <div class="d-flex flex-row mb-4">
            <span class="iconsminds-add mr-3 menu-icon-style"/>

            <p class="my-auto">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet commodi
                dolores quod, repellendus similique sint.
            </p>
        </div>

        <b-form>
            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Categories" class="has-float-label">
                        <template v-slot:label>
                            <span>Categories <sup><code>*</code></sup></span>
                        </template>

                        <v-select @input="updateCategory" v-model="selected.category" :options="categories"
                                  :border-danger="'category_id' in errors"/>

                        <b-form-invalid-feedback :state="!'category_id' in errors"
                                                 v-text="'category_id' in errors ? errors.category_id[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Concerns" class="has-float-label">
                        <template v-slot:label>
                            <span>Concerns <sup><code>*</code></sup></span>
                        </template>

                        <v-select @input="updateConcern" v-model="selected.concern" :options="concerns"
                                  :border-danger="'concern_id' in errors"/>

                        <b-form-invalid-feedback :state="!'concern_id' in errors"
                                                 v-text="'concern_id' in errors ? errors.concern_id[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Weightage" class="has-float-label">
                        <template v-slot:label>
                            <span>Weightage <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" v-model="form.weightage" :class="{'border-danger': 'weightage' in errors}"
                                      @input="'weightage' in errors ? (delete errors.weightage) : ''"
                                      autocomplete="off" placeholder="Weightage"/>

                        <b-form-invalid-feedback :state="!('weightage' in errors)"
                                                 v-text="'weightage' in errors ? errors.weightage[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Description" class="has-float-label">
                        <template v-slot:label>
                            <span>Description <sup><code>*</code></sup></span>
                        </template>

                        <b-form-textarea rows="6" v-model="form.description" :class="{'border-danger': 'description' in errors}"
                                         @input="'description' in errors ? (delete errors.description) : ''"
                                         autocomplete="off" placeholder="Description"/>

                        <b-form-invalid-feedback :state="!('description' in errors)"
                                                 v-text="'description' in errors ? errors.description[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>
        </b-form>
        <template slot="modal-footer">
            <b-button variant="outline-secondary" @click="hideModal('detail_form')" v-text="'Cancel'"/>

            <state-button v-if="!edit" variant="primary" :click="submitDetail">Submit</state-button>

            <state-button v-else variant="primary" :click="updateDetail">Update</state-button>
        </template>
    </b-modal>
</template>

<script>
import {mapGetters} from "vuex";
import StateButton from "../../../../../components/Common/StateButton";
import moment from "moment";

export default {
    name: "DetailFormModal",

    components: {
        StateButton,
    },

    props: [
        'edit'
    ],

    data() {
        return {
            loading: true,
            selected: {
                category: [],
                concern: []
            },
        }
    },

    computed: {
        ...mapGetters({
            categories: 'getSelectInspectionCategories',
            concerns: 'getSelectInspectionConcerns',
            errors: 'getInspectionDetailErrors',
            form: 'getInspectionDetailForm',
        })
    },

    watch: {
        form() {
            if (this.edit) {
                this.selected.category = this.form.select_category;
                this.selected.concern = this.form.select_concern;
            }
        },
    },

    mounted() {
        this.getForm();
    },

    methods: {
        async getForm() {
            await this.$store.dispatch('fetchSelectInspectionCategories');

            await this.$store.dispatch('fetchSelectInspectionConcerns');

            return this.loading = false;
        },

        resetForm() {
            this.$store.commit('setInspectionDetailForm');
        },

        updateCategory(field) {
            if (field) {
                this.form.category_id = field.category_id;
            } else {
                this.form.category_id = '';
            }
            'category_id' in this.errors ? delete this.errors.category_id : '';
        },

        updateConcern(field) {
            if (field) {
                this.form.concern_id = field.concern_id;
            } else {
                this.form.concern_id = '';
            }
            'concern_id' in this.errors ? delete this.errors.concern_id : '';
        },

        hideModal(refname) {
            this.$refs[refname].hide();
        },

        submitDetail() {
            return new Promise((success, fail) => {
                this.$store.dispatch('submitInspectionDetail', this.form)
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('updated');

                            this.resetForm();

                            this.$notify('success filled', 'Success!', 'Added new detail!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('detail_form');
                        }, 2000);
                    })
                    .catch(error => {
                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            })
        },

        updateDetail() {
            return new Promise((success, fail) => {
                this.$store.dispatch('updateInspectionDetail', this.form)
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('updated');

                            this.resetForm();

                            this.$notify('success filled', 'Success!', 'Updated the detail!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('detail_form');
                        }, 2000);
                    })
                    .catch(error => {
                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            })
        },
    }
}
</script>

<style scoped>

</style>
